<template>
  <v-row>
    <v-spacer/>
    <v-col cols="8" class="vert-center">
      <div class="aux-pagination-btn">
        <v-btn text>
          <v-icon color="#0000008a" @click="setPage(1)">
            mdi-chevron-double-left
          </v-icon>
        </v-btn>
      </div>
      <v-pagination
        v-model="selectedPage"
        :length="totalPages"
        :total-visible="7"
        @input="pageUpdated(selectedPage)"
      ></v-pagination>
      <div class="aux-pagination-btn">
        <v-btn text>
          <v-icon color="#0000008a" @click="setPage(totalPages)">
            mdi-chevron-double-right
          </v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="1">
      <v-text-field 
        v-model="selectedPage"
        type="number"
        :rules="rules"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    paginationInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      page: 0,
      totalPages: 0,
      rules: [
        v => ( v && v >= 1 ) || `First page cannot be less than 1`,
        v => ( v && v <= this.totalPages ) || `Cannot exceed page number greater than ${this.totalPages}`,
      ]
    }
  },
  computed: {
    selectedPage: {
      get() { 
        return parseInt(this.page); 
      },
      set(newVal) { 
        this.page = parseInt(newVal);
      }
    }
  },
  watch: {
    paginationInfo: {
      deep: true,
      handler() {
        this.mapProps()
      }
    }
  },
  mounted() {
    window.EventBus.$on('initSearchPage', this.initPage)
    this.mapProps();
  },
  methods: {
    initPage() {
      this.selectedPage = 1;
    },
    setPage(page) {
      if (!page) return;
      this.selectedPage = page;
      this.pageUpdated(page);
    },
    mapProps() {
      this.page = this.paginationInfo.pageNum;
      this.totalPages = this.paginationInfo.pageCount
    },
    pageUpdated(page) {
      this.$emit('updatedPage', page)
    }
  }
}
</script>

<style lang="scss" scoped>
  .vert-center {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }

  .aux-pagination-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0;
    margin: 0;
  }
</style>